<div class="close-button">
  <button matIconButton aria-label="Close navigation menu" (click)="close()">
    <mat-icon>menu_open</mat-icon>
  </button>
</div>

<!-- role="list" overrides MatNavList's own role="navigation": the landmark is the enclosing
     mat-sidenav (aria-label="Online Services"), which also names this list — so no label here. -->
<mat-nav-list class="navigation" role="list">
  <!-- The narrow header has no room for the wide header's Home button, so Home lives here,
  where it is reachable whether or not the user is signed in -->
  <!-- aria-current comes from routerLinkActive on every link: it removes the attribute on each
  update unless ariaCurrentWhenActive is set, so an [attr.aria-current] binding would be wiped
  as soon as the router navigates. Home matches exactly, since every URL starts with / -->
  <a
    class="navigation-link mat-focus-indicator"
    matRipple
    routerLink="/"
    routerLinkActive
    [routerLinkActiveOptions]="{ exact: true }"
    ariaCurrentWhenActive="page">
    <span class="navigation-link__title">Home</span>
  </a>
  @for (item of menuItems; track item.menuItemId) {
    @let underMaintenance = siteMetadataService.isPageUnderMaintenance(item.pageId);
    <!-- A flagged entry needs role AND tabindex to reach the accessibility tree as disabled: an
    anchor with no routerLink has no href and therefore no link role, and Chrome prunes the node
    entirely while it is unfocusable. With both, it reads as a disabled link carrying the notice
    below; without them it collapses to loose text with no disabled state at all. -->
    <!-- Plain markup, not mat-list-item: MDC's list-item content only ever renders at one of
    three fixed heights (48/64/88px) with the description elided or clamped to a set line
    count. Owning the row lets a description wrap and size to however many lines it actually
    needs, same as .action-card (styles/utilities/_action-card.scss). -->
    <a
      class="navigation-link mat-focus-indicator"
      matRipple
      [matRippleDisabled]="underMaintenance"
      [class.navigation-link--disabled]="underMaintenance"
      routerLinkActive="navigation-link--active"
      ariaCurrentWhenActive="page"
      [attr.aria-disabled]="underMaintenance"
      [attr.role]="underMaintenance ? 'link' : null"
      [attr.tabindex]="underMaintenance ? 0 : null"
      [routerLink]="underMaintenance ? null : ['/search/' + item.pageId]">
      <span class="navigation-link__title">{{ item.label }}</span>
      @if (item.description) {
        <span class="navigation-link__description">{{ item.description }}</span>
      }
      @if (underMaintenance) {
        <span class="navigation-link__description">{{ siteMetadataService.maintenanceNotice }}</span>
      }
    </a>
  }
</mat-nav-list>